import React from "react";
import { useNavigate } from "react-router-dom";
import {
 FiShoppingBag
} from "react-icons/fi";
import "./home.css";

export default function Home() {
      const navigate = useNavigate();
  return (
    <>
      {/* Hero Section */}
      <section
        className="heroBanner"
        style={{ backgroundImage: "url('/main1.png')" }}
      >
        <div className="heroInner">
          <div className="heroLeft">
            <h1>Carry Your Calm.</h1>

            <p className="line1">
             Tote Therapy
Carry your calm in a city that never sleeps.
            </p>

            <p className="line2">
            In the heart of Dubai’s fast-paced life, we created something simple,
             a reminder you can carry every day.
            </p>

 <button
          className="heroBtn"
          onClick={() => navigate("/shop")}
        >
        <FiShoppingBag />  Shop the Collection
        </button>
          </div>
        </div>
      </section>

      {/* New City Section */}
      <section className="citySection">
        <div className="cityContent">
          <h2>Born in a 24/7 City.</h2>
          <p className="subLine">Dubai moves fast.</p>
          <p>
            Wake up. Work. Eat. Sleep. Repeat.   <br />
           Deadlines. Traffic. Meetings. Noise. Expectations.
Somewhere in between ambition and exhaustion, we forget to check in with ourselves.
Tote Therapy was created as a daily reminder for you and for anyone who reads what you carry.
A reminder to pause.
A reminder to breathe.
A reminder to stay mentally aware.
This isn’t just a tote bag.
It’s everyday therapy.
          </p>
        </div>
      </section>
      <section className="quoteSection">
  <div className="quoteWrapper">

    <div className="quoteCard left">
      <h3>Healing Quotes</h3>
      <p>Gentle reminders for <br/> emotional awareness.</p>
      <span className="arrow">→</span>
    </div>

    <div className="quoteCard middle">
      <h3>Soft Strength</h3>
      <p>Feminine, gentle,<br/> and empowering.</p>
      <span className="arrow">→</span>
    </div>

    <div className="quoteCard right">
      <h3>Urban Mind</h3>
      <p>Bold statements for<br/> modern city life.</p>
      <span className="arrow">→</span>
    </div>

  </div>
</section>
      {/* Mission & Vision (Card Style like screenshot) */}
<section className="mvSection">
  <div className="mvContainer">

    {/* MISSION CARD */}
    <div className="mvCard">
      <h3>OUR MISSION</h3>
      <ul>
        <li>To make mental awareness visible.</li>
        <li>To normalize rest in a culture that glorifies hustle.</li>
        <li>To turn everyday fashion into emotional reminders.</li>
        <li>To remind you that success means nothing without peace.</li>
      </ul>
    </div>

    {/* VISION CARD */}
    <div className="mvCard">
      <h3>OUR VISION</h3>
      <ul>
        <li>A community that carries awareness.</li>
        <li>A lifestyle brand that speaks softly but powerfully.</li>
        <li>A movement where fashion becomes a message.</li>
      </ul>
    </div>

  </div>
</section>
    </>
  );
}